/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelEntityModelClientDto } from '../models/PagedModelEntityModelClientDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ClientControllerService {

  /**
   * Returns a paged list of Client entities
   * @returns PagedModelEntityModelClientDto Paged list of Client entities
   * @throws ApiError
   */
  public static getAllClients({
page,
size = 10,
sort,
search,
idList,
authorization,
number,
zipCode,
firstname,
address,
id,
clientNumber,
clientDetailNumber,
fileTimestamp,
residence,
newPurchaser,
lastname,
}: {
/**
 * Zero-based page index (0..N)
 */
page?: number,
/**
 * The size of the page to be returned
 */
size?: number,
/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
sort?: Array<string>,
search?: string,
idList?: Array<number>,
authorization?: string,
number?: string,
zipCode?: string,
firstname?: string,
address?: string,
id?: number,
clientNumber?: string,
clientDetailNumber?: string,
fileTimestamp?: string,
residence?: string,
newPurchaser?: string,
lastname?: string,
}): CancelablePromise<PagedModelEntityModelClientDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/client',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'page': page,
        'size': size,
        'sort': sort,
        'search': search,
        'idList': idList,
        'number': number,
        'zipCode': zipCode,
        'firstname': firstname,
        'address': address,
        'id': id,
        'clientNumber': clientNumber,
        'clientDetailNumber': clientDetailNumber,
        'fileTimestamp': fileTimestamp,
        'residence': residence,
        'newPurchaser': newPurchaser,
        'lastname': lastname,
      },
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
